import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { ProgressIndicator } from '../../components/authentication/progress-indicator'
import { Paths } from '../../config/routes'
import { getVerificationText } from '../../lib/auth-helpers'
import { ConfirmStep } from './confirm-step'
import { RequestStep } from './request-step'

export const I18n = {
    STEP1_TITLE: 'Reset passowrd',
    STEP2_TITLE: 'Verify and update password',
}

export type Steps = 'request' | 'confirm'

export function ResetPasswordFlow() {
    const history = useHistory()
    const [step, setStep] = React.useState<Steps>('request')
    const [email, setEmail] = React.useState('')

    const [message, setMessage] = React.useState('')
    let content: any = null

    if (step === 'request') {
        content = (
            <RequestStep
                onComplete={(formData, res) => {
                    setEmail(formData.email)

                    if (res?.CodeDeliveryDetails) {
                        setMessage(
                            getVerificationText(
                                res?.CodeDeliveryDetails?.DeliveryMedium,
                                res?.CodeDeliveryDetails?.Destination,
                            ),
                        )
                    }

                    setStep('confirm')
                }}
            />
        )
    }

    if (step === 'confirm') {
        content = (
            <ConfirmStep
                email={email}
                subHeading={message}
                onComplete={() => {
                    history.push(Paths.SIGN_IN)
                }}
            />
        )
    }

    return (
        <div className='pt-6 md:pt-12'>
            <ProgressIndicator
                step={step === 'request' ? 1 : 2}
                total={2}
                stepText={[I18n.STEP1_TITLE, I18n.STEP2_TITLE]}
                onBack={() => {
                    if (step === 'confirm') {
                        setStep('request')
                    } else {
                        history.push(Paths.SIGN_IN)
                    }
                }}
            />
            <div className='max-w-lg'>{content}</div>
        </div>
    )
}
